import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Plus, User, CheckCircle2, Info } from 'lucide-react';
import { familyMembers } from '../data/mockData';
import { useAppContext } from '../contexts/AppContext';
export function FamilyProfilesScreen() {
  const navigate = useNavigate();
  const {
    activeFamilyMemberId,
    setActiveFamilyMemberId
  } = useAppContext();
  const [showAddForm, setShowAddForm] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="flex flex-col min-h-screen bg-slate-50" data-id="element-367">
      <div className="bg-white px-6 pt-12 pb-4 shadow-sm sticky top-0 z-10 flex items-center justify-between" data-id="element-368">
        <div className="flex items-center gap-3" data-id="element-369">
          <button onClick={() => navigate(-1)} className="p-2 -ml-2 hover:bg-slate-50 rounded-full" data-id="element-370">
            <ArrowLeft className="w-6 h-6 text-slate-700" data-id="element-371" />
          </button>
          <h1 className="text-xl font-bold text-slate-900" data-id="element-372">Family Profiles</h1>
        </div>
        {!showAddForm && <button onClick={() => setShowAddForm(true)} className="p-2 text-blue-600 hover:bg-blue-50 rounded-full flex items-center gap-1" data-id="element-373">
            <Plus className="w-5 h-5" data-id="element-374" />
          </button>}
      </div>

      <div className="p-6 flex-1 overflow-y-auto" data-id="element-375">
        <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 flex gap-3 mb-6" data-id="element-376">
          <Info className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" data-id="element-377" />
          <p className="text-sm text-blue-800" data-id="element-378">
            Switch the active profile before booking an appointment to ensure
            records are saved correctly.
          </p>
        </div>

        {showAddForm ? <div className="bg-white p-5 rounded-2xl shadow-sm border border-slate-100" data-id="element-379">
            <h2 className="font-semibold text-slate-900 mb-4" data-id="element-380">
              Add Family Member
            </h2>
            <div className="space-y-4" data-id="element-381">
              <div data-id="element-382">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-383">
                  Full Name
                </label>
                <input type="text" className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600" placeholder="e.g. John Doe" data-id="element-384" />
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-385">
                <div data-id="element-386">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-387">
                    Age
                  </label>
                  <input type="number" className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600" placeholder="e.g. 30" data-id="element-388" />
                </div>
                <div data-id="element-389">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-390">
                    Relationship
                  </label>
                  <select className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600" data-id="element-391">
                    <option data-id="element-392">Spouse</option>
                    <option data-id="element-393">Child</option>
                    <option data-id="element-394">Parent</option>
                    <option data-id="element-395">Sibling</option>
                    <option data-id="element-396">Other</option>
                  </select>
                </div>
              </div>
              <div data-id="element-397">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-398">
                  Medical Notes (Optional)
                </label>
                <textarea className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600" rows={3} placeholder="Allergies, chronic conditions..." data-id="element-399" />
              </div>
              <div className="flex gap-3 pt-2" data-id="element-400">
                <button onClick={() => setShowAddForm(false)} className="flex-1 py-3 rounded-xl border border-slate-200 text-slate-700 font-medium text-sm" data-id="element-401">
                  Cancel
                </button>
                <button onClick={() => setShowAddForm(false)} className="flex-1 py-3 rounded-xl bg-blue-600 text-white font-medium text-sm" data-id="element-402">
                  Save Profile
                </button>
              </div>
            </div>
          </div> : <div className="space-y-3" data-id="element-403">
            {familyMembers.map(member => <div key={member.id} onClick={() => setActiveFamilyMemberId(member.id)} className={`p-4 rounded-2xl border-2 cursor-pointer transition-colors flex items-center justify-between ${activeFamilyMemberId === member.id ? 'border-blue-600 bg-blue-50' : 'border-transparent bg-white shadow-sm'}`} data-id="element-404">
                <div className="flex items-center gap-4" data-id="element-405">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center shrink-0 ${activeFamilyMemberId === member.id ? 'bg-blue-200' : 'bg-slate-100'}`} data-id="element-406">
                    <User className={`w-6 h-6 ${activeFamilyMemberId === member.id ? 'text-blue-700' : 'text-slate-500'}`} data-id="element-407" />
                  </div>
                  <div data-id="element-408">
                    <div className="flex items-center gap-2" data-id="element-409">
                      <h3 className="font-semibold text-slate-900" data-id="element-410">
                        {member.name}
                      </h3>
                      {member.relation === 'Self' && <span className="text-[10px] font-bold uppercase tracking-wider bg-slate-200 text-slate-600 px-2 py-0.5 rounded-full" data-id="element-411">
                          Me
                        </span>}
                    </div>
                    <p className="text-sm text-slate-500 mt-0.5" data-id="element-412">
                      {member.relation !== 'Self' ? `${member.relation} • ` : ''}
                      {member.age} yrs • {member.gender}
                    </p>
                    {member.notes && <p className="text-xs text-slate-400 mt-1 line-clamp-1" data-id="element-413">
                        {member.notes}
                      </p>}
                  </div>
                </div>
                {activeFamilyMemberId === member.id && <CheckCircle2 className="w-6 h-6 text-blue-600 shrink-0" data-id="element-414" />}
              </div>)}
          </div>}
      </div>
    </motion.div>;
}